import { UsersImport } from './Import'
const { RoutesMap, Profile, StaffList, AssignDepartmentList } = UsersImport

const UsersRoute = () => {
    return [
        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },
        {
            path: RoutesMap.STAFF_LIST.path,
            element: <StaffList />
        },
        {
            path: RoutesMap.ASSIGN_DEPARTMENT_LIST.path,
            element: <AssignDepartmentList />
        },
    ]
}

export default UsersRoute;